import React from 'react';
import escavatoriImage from '../assets/escavatori.jpg'; 
import logo from '../assets/escavatorirentpiccolo.png';

import { Link } from 'react-router-dom';

function Header() {
  return (
    <header className="relative bg-cover bg-center h-96 flex items-center justify-center text-white p-4" style={{ backgroundImage: `url(${escavatoriImage})` }}>
      <div className="absolute inset-0 bg-black opacity-50"></div>
      <div className="relative z-10 flex flex-col md:flex-row justify-between items-center w-full space-y-4 md:space-y-0">
   <Link to="/"> <img className='opacity-80 rounded-full' src={logo} alt="Noleggio escavatori" /></Link> 
        <nav>
          <ul className="flex flex-col md:flex-row text-center space-y-2 md:space-y-0 md:space-x-4">
            {/* <li><a href="#chi-siamo" className="hover:underline text-sm">Chi Siamo</a></li>
            <li><a href="#servizi" className="hover:underline text-sm">Servizi</a></li> */}

            <Link to="/" className="text-white mr-4">Home</Link>
            {/* <Link to="chi-siamo" className="text-white mr-4">Chi siamo</Link>
            <Link to="servizi" className="text-white mr-4">Servizi</Link> */}
          </ul>
        </nav>
      </div>
    </header>
  );
}

export default Header;

